export default __webpack_public_path__ + "static/media/complementary--motorcycles--g1.511b5604.png";